import React from 'react'
import 'regenerator-runtime/runtime'
import Challenges from '../../routes/Challenges'
import Head from 'next/head'

const Routes = () => {
  return (
    <>
      <Head>
        <title>Challenges – DecorMatters</title>
      </Head>
      <Challenges />
    </>
  )
}

export default Routes
